<script>
import Slick from "vue-slick";
import VueScrollTo from "vue-scrollto";

export default {
  data() {
    return {
      slickOptions: {
        //options can be used from the plugin documentation
        slidesToShow: 1,
        infinite: false,
        accessibility: true,
        adaptiveHeight: window.innerWidth < 768 ? true : false,
        arrows: true,
        dots: true,
        draggable: false,
        edgeFriction: 0.3,
        swipe: true
      }
    };
  },
  methods: {
    handleInit(event, slick) {
      slick.$dots.append('<li class="count-max">' + slick.slideCount + "</li>");
      document.getElementById("scrollTrigger").click();
    }
  },
  components: {
    slick: Slick
  }
};
</script>

<template>
  <article id="article_conoscermi" class="do-article">
    <a class="hidden" id="scrollTrigger" v-scroll-to="{ el: '#article_conoscermi', duration: 1 }"></a>
    <div class="row no-gutters">
      <div class="col-xl-4 col-lg-5">
        <div class="do-article-info">
          <progressive-background src="static/images/article1.png"/>
          <h2>PAURA DI CONOSCERMI?</h2>
          <p>
            Da quando è stata inventata, più di un secolo fa, la
            <strong>plastica</strong> ha
            <strong>rivoluzionato</strong> il nostro modo di vivere.
            La plastica ha svolto, e svolge tuttora, un ruolo fondamentale nel migliorare la
            <strong>qualità della vita</strong> delle persone: non c’è attività umana che non sia significativamente progredita grazie a questo straordinario materiale.
          </p>
          <p>
            Non darla per
            <strong>scontata</strong>: la tua
            <strong>
              vita non sarebbe la
              stessa se non esistesse
            </strong>.
          </p>
          <p>Ecco cosa la rende unica.</p>
        </div>
      </div>
      <div class="col-xl-8 col-lg-7">
        <div class="do-article-content">
          <router-link class="do-back" to="/">
            <img src="static/images/back.svg" alt="Go Back">
          </router-link>

          <div class="do-article-slider">
            <slick ref="slick" :options="this.slickOptions" @init="handleInit">
              <!-- Slide -->
              <div class="do-slide">
                <div class="row mt-4">
                  <div class="col-12">
                    <h3>LEGGEREZZA</h3>
                  </div>
                  <div class="col-xl-8">
                    <p>
                      Rispetto ai materiali tradizionali, la
                      <strong>plastica</strong> rende i prodotti molto più leggeri, in questo modo il loro trasporto e impiego richiede molto meno combustibile.
                      Il
                      <strong>peso degli imballaggi</strong> si alleggerisce di quasi
                      <strong>4 volte</strong>, così si risparmia energia, si
                      <strong>
                        riducono le emissioni di CO<sub>2</sub>
                      </strong> e si riduce il numero dei veicoli in circolazione.
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <img class="w-100 mw-260 mb-4" src="static/images/article1-img1.svg" alt>
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-12">
                    <h3>SICUREZZA</h3>
                  </div>
                  <div class="col-xl-8">
                    <p>
                      Le materie plastiche sono <strong>sicure</strong>. In Europa le sostanze chimiche utilizzate per produrre le plastiche sono soggette a una <strong>doppia legislazione</strong> che ne regola rigorosamente l’uso: la prima, detta <strong>REACH</strong>, prevede l’<strong>analisi</strong> e la valutazione di tutte le sostanze chimiche (<strong>30.000</strong> in Europa).  
                    </p>
                    <p>
                      Un secondo insieme di norme, di carattere europeo e nazionale, ne definisce l’<strong>utilizzo</strong> nei vari ambiti, per citare le applicazioni più comuni: imballaggi alimentari, costruzioni, elettrodomestici, medicale, giocattoli.
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <img class="w-100 mw-260 mh-180 mb-4" src="static/images/article1-img2.svg" alt>
                  </div>
                </div>
              </div>
              <!-- / Slide -->

              <!-- Slide -->
              <div class="do-slide">
                <div class="row mt-4 h-100">
                  <div class="col-12 mb-4">
                    <h3>SOSTENIBILITÀ</h3>
                  </div>

                  <div class="col-xl-6 col-lg-12 col-md-6">
                    <h4>Economica</h4>
                    <p>
                      La plastica è <strong>economica</strong> e permette di produrre beni che migliorano gli <strong>standard di vita</strong> delle persone.   
                    </p>
                  </div>
                  <div class="col-xl-6 col-lg-12 col-md-6">
                    <h4>Sociale</h4>
                    <p>
                      In Europa l’Industria delle plastiche, indotto incluso, offre <strong>lavoro</strong> a più di <strong>un milione e mezzo di persone</strong>, con un mercato di <strong>159 miliardi di euro</strong>. 
                    </p>
                  </div>
                  <div class="col-xl-6 col-lg-12 col-md-6">
                    <h4>Ambientale</h4>
                    <p>
                      La plastica contribuisce a ridurre l'<strong>energia</strong> impiegata nei <strong>processi produttivi</strong>, consente un significativo risparmio energetico durante la fase di vita e, alla fine del suo utilizzo, può essere smaltita con facilità. 
                      Il suo utilizzo nell’industria delle <strong>energie rinnovabili</strong> è di estrema importanza: pale e turbine eoliche, pannelli solari sono costituiti da materiali plastici. La plastica sotto questi punti di vista è una soluzione vincente.
                    </p>
                  </div>
                  <div class="col-xl-6 col-lg-12 col-md-6 mt-auto">
                    <img class="w-100 mw-260 mh-180" src="static/images/article1-img3.svg" alt>
                  </div>
                </div>
              </div>
              <!-- / Slide -->

              <!-- Slide -->
              <div class="do-slide">
                <div class="row h-100 align-content-center">
                  <div class="col-12">
                    <h3>VERSATILITÀ</h3>
                  </div>
                  <div class="col-xl-8">
                    <p>
                      Può essere <strong>trasformata</strong> in un’incredibile <strong>varietà di forme</strong> complesse. Ha mille volti: più dura dell’acciaio, più soffice della seta, di ogni forma e colore. È il motivo per cui designer e progettisti la amano tanto. 
                    </p>
                    <p>
                      I componenti di plastica possono essere <strong>facilmente modificati</strong> - in dimensione, estetica o funzione - o <strong>sostituiti</strong>. Quando un manufatto giunge a fine vita, prima del suo smaltimento, le sue parti in plastica possono essere recuperate e <strong>riutilizzate</strong>, <strong>riciclate</strong> o <strong>trasformate in energia termica</strong>. 
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <img class="w-100 mw-260 mh-180" src="static/images/article1-img4.svg" alt>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
            </slick>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

          <!-- <div class="row">
            <div class="col-xl-8 col-lg-12 col-md-8">
              <h3>Lorem Ipsum</h3>
              <ul>
                <li>
                  Lorem Ipsum è un testo segnaposto utilizzato nel settore della tipografia e della
                  stampa. Lorem Ipsum è considerato il testo segnaposto standard sin dal sedicesimo
                  secolo, quando un anonimo tipografo prese una cassetta di caratteri e li assemblò
                  per preparare un testo campione.
                </li>
                <li>
                  Lorem Ipsum è un testo segnaposto utilizzato nel settore della tipografia e della
                  stampa.
                </li>
                <li>
                  Lorem Ipsum è un testo segnaposto utilizzato nel settore della tipografia e della
                  stampa. Lorem Ipsum è considerato il testo segnaposto standard sin dal sedicesimo
                  secolo, quando un anonimo tipografo prese una cassetta di caratteri e li assemblò
                  per preparare un testo campione.
                </li>
                <li>
                  Lorem Ipsum è un testo segnaposto utilizzato nel settore della tipografia e della
                  stampa.
                </li>
              </ul>
            </div>
            <div class="col-xl-4 col-lg-12 col-md-4">
              <div class="do-figure-wrap">
                <figure>
                  <img src="static/images/innovation.png" alt="Innovation">
                  <figcaption>
                    <h5>Innovation</h5>Lorem Ipsum è un testo segnaposto utilizzato nel settore della tipografia e della
                    stampa.
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>-->


// WEBPACK FOOTER //
// src/components/Conoscermi.vue